/**
 * @module modules/chart-tooltip-sk
 * @description <h2><code>chart-tooltip-sk</code></h2>
 *
 * @evt
 *
 * @attr
 *
 * @example
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ChartTooltipSk", {
    enumerable: true,
    get: function() {
        return ChartTooltipSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _ref = require("lit/directives/ref.js");
const _anomaly = require("../common/anomaly");
require("../commit-range-sk/commit-range-sk");
require("../window/window");
require("../triage-menu-sk/triage-menu-sk");
require("../user-issue-sk/user-issue-sk");
require("../bisect-dialog-sk/bisect-dialog-sk");
require("../pinpoint-try-job-dialog-sk/pinpoint-try-job-dialog-sk");
require("../../../elements-sk/modules/icons/close-icon-sk");
require("@material/web/elevation/elevation.js");
const _paramtools = require("../paramtools");
require("../point-links-sk/point-links-sk");
const _plotbuilder = require("../common/plot-builder");
require("../json-source-sk/json-source-sk");
const _testpicker = require("../common/test-picker");
const _commit = require("../common/commit");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ChartTooltipSk = class ChartTooltipSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <div class="container" ${(0, _ref.ref)(this.containerDiv)}>
        <md-elevation></md-elevation>
        <button id="closeIcon" @click=${this._close_button_action} ?hidden=${!this.tooltip_fixed}>
          <close-icon-sk></close-icon-sk>
        </button>
        <h3>
          <span style="color:${this.color}">
            ${this.test_name || `${_testpicker.DEFAULT_OPTION_LABEL}`}
            <span ?hidden=${!this.anomaly}> [Anomaly] </span>
          </span>
        </h3>
        <ul class="table">
          <li>
            <span id="tooltip-key">Date</span>
            <span id="tooltip-text">${this.date_value.toUTCString()}</span>
          </li>
          <li>
            <span id="tooltip-key">Value</span>
            <span id="tooltip-text">${this.y_value} ${this.unit_type}</span>
          </li>
          <li>
            <span id="tooltip-key">Point Range</span>
            <commit-range-sk id="tooltip-commit-range-link"></commit-range-sk>
          </li>
        </ul>
        <point-links-sk id="tooltip-point-links"></point-links-sk>
        ${this.getCommitInfo()} ${this.anomalyTemplate()}
        <triage-menu-sk id="triage-menu" ?hidden=${!(this.anomaly && this.anomaly.bug_id === 0)}>
        </triage-menu-sk>

        <ul class="table" ?hidden=${!this.show_bisect_button && !this._show_pinpoint_buttons}>
          <li>
            <span id="tooltip-key">Pinpoint</span>
            <div class="buttons">
              <button
                id="bisect"
                @click=${this.openBisectDialog}
                ?hidden=${!this.show_bisect_button}>
                Bisect
              </button>
              <button
                id="try-job"
                @click=${this.openTryJobDialog}
                ?hidden=${!this._show_pinpoint_buttons}>
                Request Trace
              </button>
            </div>
          </li>
        </ul>

        <ul class="table" ?hidden=${!!this.anomaly}>
          <li>
            <span id="tooltip-key">User Issues</span>
            <div class="buttons">
              <user-issue-sk id="tooltip-user-issue-sk"></user-issue-sk>
            </div>
          </li>
        </ul>

        <div id="json-source-dialog" ?hidden=${!this.json_source}>
          <json-source-sk id="json-source-sk"></json-source-sk>
        </div>
        <bisect-dialog-sk id="bisect-dialog-sk"></bisect-dialog-sk>
        <pinpoint-try-job-dialog-sk id="pinpoint-try-job-dialog-sk"></pinpoint-try-job-dialog-sk>
      </div>
    `;
    }
    moveTo(position) {
        var _div_parentElement, _this_parentElement;
        const div = this.containerDiv.value;
        if (!div) {
            return;
        }
        if (!position) {
            div.style.display = 'none';
            return;
        }
        div.style.display = 'block';
        const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        var _this_margin_left;
        this.margin.left = (_this_margin_left = this.margin.left) !== null && _this_margin_left !== void 0 ? _this_margin_left : parseInt(getComputedStyle(div).marginLeft);
        var _this_margin_right;
        this.margin.right = (_this_margin_right = this.margin.right) !== null && _this_margin_right !== void 0 ? _this_margin_right : parseInt(getComputedStyle(div).marginRight);
        var _this_margin_top;
        this.margin.top = (_this_margin_top = this.margin.top) !== null && _this_margin_top !== void 0 ? _this_margin_top : parseInt(getComputedStyle(div).marginTop);
        var _this_margin_bottom;
        this.margin.bottom = (_this_margin_bottom = this.margin.bottom) !== null && _this_margin_bottom !== void 0 ? _this_margin_bottom : parseInt(getComputedStyle(div).marginBottom);
        const parentLeft = ((_div_parentElement = div.parentElement) === null || _div_parentElement === void 0 ? void 0 : _div_parentElement.getBoundingClientRect().left) || 0;
        const parentTop = ((_this_parentElement = this.parentElement) === null || _this_parentElement === void 0 ? void 0 : _this_parentElement.getBoundingClientRect().top) || 0;
        const rect = div.getBoundingClientRect();
        const left = parentLeft + position.x + this.margin.left + rect.width;
        const top = parentTop + position.y + this.margin.top + rect.height;
        const adjustedX = left > viewportWidth ? position.x - (rect.width + this.margin.left + this.margin.right) : position.x;
        const adjustedY = top > viewportHeight ? position.y - (top - viewportHeight) : position.y;
        div.style.left = `${adjustedX}px`;
        div.style.top = `${adjustedY}px`;
    }
    getCommitInfo() {
        var _this_commit_info, _this_commit_info1, _this_commit_info2, _this_commit_info3;
        if (this.commit_info === null || (this._is_range || this._is_range === null) && !this._always_show_commit_info) {
            return (0, _lit.html)``;
        }
        return (0, _lit.html)`<ul class="table">
      <li>
        <span id="tooltip-key">Author</span>
        <span id="tooltip-text">${(_this_commit_info = this.commit_info) === null || _this_commit_info === void 0 ? void 0 : _this_commit_info.author.split('(')[0]} </span>
      </li>
      <li>
        <span id="tooltip-key">Message</span>
        <span id="tooltip-text">${(_this_commit_info1 = this.commit_info) === null || _this_commit_info1 === void 0 ? void 0 : _this_commit_info1.message} </span>
      </li>
      <li>
        <span id="tooltip-key">Commit</span>
        <span id="tooltip-text">
          <a href="${(_this_commit_info2 = this.commit_info) === null || _this_commit_info2 === void 0 ? void 0 : _this_commit_info2.url}" target="_blank">${(0, _commit.TrimHash)((_this_commit_info3 = this.commit_info) === null || _this_commit_info3 === void 0 ? void 0 : _this_commit_info3.hash)}</a>
        </span>
      </li>
    </ul>`;
    }
    anomalyTemplate() {
        if (this.anomaly === null) {
            var _this_triageMenu;
            (_this_triageMenu = this.triageMenu) === null || _this_triageMenu === void 0 ? void 0 : _this_triageMenu.toggleButtons(true);
            return (0, _lit.html)``;
        }
        if (this.anomaly.is_improvement) {
            this._nudgeList = null;
        }
        if (this.anomaly.bug_id === 0) {
            this.triageMenu.setAnomalies([
                this.anomaly
            ], [
                this._trace_name
            ], this._nudgeList);
        }
        return (0, _lit.html)`
      <ul class="table" id="anomaly-details">
        <li>
          <span id="tooltip-key">Anomaly</span>
          <span id="tooltip-text">${this.anomalyType()}</span>
        </li>
        <li>
          <span id="tooltip-key">Anomaly Range</span>
          <commit-range-sk id="anomaly-commit-range-link"></commit-range-sk>
        </li>
        <li>
          <span id="tooltip-key">Median</span>
          <span id="tooltip-text">
            ${(0, _anomaly.formatNumber)(this.anomaly.median_after_anomaly)} ${this.unit_type.split(' ')[0]}
          </span>
        </li>
        <li>
          <span id="tooltip-key">Previous</span>
          <span id="tooltip-text">
            ${(0, _anomaly.formatNumber)(this.anomaly.median_before_anomaly)} [${this.anomalyChange()}%]
          </span>
        </li>
        ${this.anomaly.multiplicity ? (0, _lit.html)` <li>
              <span id="tooltip-key">Multiplicity</span>
              <span id="tooltip-text"> ${this.anomaly.multiplicity} </span>
            </li>` : ''}
        ${this.anomaly.is_legacy ? (0, _lit.html)` <li>
              <span id="tooltip-key">Legacy anomaly</span>
              <span id="tooltip-text"> </span>
            </li>` : ''}
        ${this.anomaly.bug_id ? (0, _lit.html)` <li>
              <span id="tooltip-key">Bug ID</span>
              <span id="tooltip-text">${(0, _anomaly.formatBug)(this.bug_host_url, this.anomaly.bug_id)}</span>
              <close-icon-sk
                id="unassociate-bug-button"
                @click=${this.unassociateBug}
                ?hidden=${this.anomaly.bug_id === 0}>
              </close-icon-sk>
            </li>` : ''}
        <li>${this.pinpointJobLinks()}</li>
      </ul>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('anomaly-changed', ()=>{
            this.requestUpdate();
        });
        this.addEventListener('user-issue-changed', (e)=>{
            this.bug_id = e.detail.bug_id;
        });
    }
    anomalyType() {
        if (this.anomaly.is_improvement) {
            return (0, _lit.html)`<span class="improvement">Improvement</span>`;
        }
        return (0, _lit.html)`<span class="regression">Regression</span>`;
    }
    anomalyChange() {
        let divClass = 'regression';
        const change = (0, _anomaly.formatPercentage)((0, _anomaly.getPercentChange)(this.anomaly.median_before_anomaly, this.anomaly.median_after_anomaly));
        if (this.anomaly.is_improvement) {
            divClass = 'improvement';
        }
        return (0, _lit.html)`<span class="${divClass}">${change}</span>`;
    }
    pinpointJobLinks() {
        if (!this.anomaly || !this.anomaly.bisect_ids || this.anomaly.bisect_ids.length === 0) {
            return (0, _lit.html)``;
        }
        const links = this.anomaly.bisect_ids.map((id)=>(0, _lit.html)`<a href="https://pinpoint-dot-chromeperf.appspot.com/job/${id}" target="_blank"
          >${id}</a
        >`);
        return (0, _lit.html)` <span id="tooltip-key">Pinpoint</span>
      <span id="tooltip-text">
        ${links.map((link, index)=>(0, _lit.html)`${link}${index < links.length - 1 ? (0, _lit.html)`<br />` : ''}`)}
      </span>`;
    }
    load(index, test_name, trace_name, unit_type, y_value, date_value, commit_position, bug_id, anomaly, nudgeList, commit, tooltipFixed, commitRange, closeButtonAction, color, user_id) {
        this.index = index;
        this.test_name = test_name;
        this._trace_name = trace_name;
        this.unit_type = unit_type.replace('_', ' ');
        this.y_value = y_value;
        this.date_value = date_value;
        this.commit_position = commit_position;
        this.bug_id = bug_id;
        this.anomaly = anomaly;
        this._nudgeList = nudgeList;
        this._close_button_action = closeButtonAction;
        this.tooltip_fixed = tooltipFixed;
        this.commit_info = commit;
        this.color = color || _plotbuilder.defaultColors[this.index % _plotbuilder.defaultColors.length];
        if (commitRange && this.commitRangeSk) {
            this._is_range = commitRange.isRange();
            this.commitRangeSk.hashes = commitRange.hashes;
            this.commitRangeSk.trace = commitRange.trace;
            this.commitRangeSk.header = commitRange.header;
            this.commitRangeSk.commitIndex = commitRange.commitIndex;
        }
        if (this.userIssueSk) {
            var _this_commit_position;
            this.userIssueSk.user_id = user_id || '';
            this.userIssueSk.bug_id = bug_id;
            this.userIssueSk.trace_key = (0, _paramtools.formatSpecialFunctions)(this._trace_name);
            const commitPos = ((_this_commit_position = this.commit_position) === null || _this_commit_position === void 0 ? void 0 : _this_commit_position.toString()) || '';
            this.userIssueSk.commit_position = parseInt(commitPos);
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('anomaly') && this.anomaly) {
            const anomalyRangeSk = this.querySelector('#anomaly-commit-range-link');
            if (anomalyRangeSk) {
                const prev_commit = this.anomaly.start_revision - 1;
                const commit = this.anomaly.end_revision;
                anomalyRangeSk.setRange(prev_commit, commit);
            }
        }
    }
    loadPointLinks(commit_position, prev_commit_position, trace_id, keysForCommitRange, keysForUsefulLinks, commitLinks) {
        return this.pointLinks.load(commit_position, prev_commit_position, trace_id, keysForCommitRange, keysForUsefulLinks, commitLinks);
    }
    loadJsonResource(commit_position, trace_id) {
        if (this.jsonSourceDialog === null || commit_position === null || trace_id === null) {
            return;
        }
        this.jsonSourceDialog.cid = commit_position;
        this.jsonSourceDialog.traceid = trace_id;
    }
    reset() {
        var _this_commitRangeSk, _this_pointLinks, _this_bisectDialog;
        this.bug_id = 0;
        this.index = -1;
        this.commit_info = null;
        (_this_commitRangeSk = this.commitRangeSk) === null || _this_commitRangeSk === void 0 ? void 0 : _this_commitRangeSk.reset();
        (_this_pointLinks = this.pointLinks) === null || _this_pointLinks === void 0 ? void 0 : _this_pointLinks.reset();
        (_this_bisectDialog = this.bisectDialog) === null || _this_bisectDialog === void 0 ? void 0 : _this_bisectDialog.reset();
    }
    unassociateBug() {
        this.triageMenu.makeEditAnomalyRequest([
            this.anomaly
        ], [
            this._trace_name
        ], 'RESET');
    }
    openBisectDialog() {
        this.bisectDialog.open();
    }
    openTryJobDialog() {
        this.tryJobDialog.open();
    }
    setBisectInputParams(preloadInputs) {
        this.bisectDialog.setBisectInputParams(preloadInputs);
    }
    setTryJobInputParams(preloadInputs) {
        this.tryJobDialog.setTryJobInputParams(preloadInputs);
    }
    openNewBug() {
        if (this.triageMenu) {
            this.triageMenu.fileBug();
        }
    }
    openExistingBug() {
        if (this.triageMenu) {
            this.triageMenu.openExistingBugDialog();
        }
    }
    ignoreAnomaly() {
        if (this.triageMenu) {
            this.triageMenu.ignoreAnomaly();
        }
    }
    constructor(...args){
        var _window_perf_git_repo_url, _window_perf, _window_perf1;
        super(...args);
        this.index = -1;
        this.color = '';
        this.test_name = '';
        this._trace_name = '';
        this.unit_type = '';
        this.y_value = -1;
        this.date_value = new Date();
        this.commit_position = null;
        this.commit_info = null;
        this.anomaly = null;
        this._nudgeList = null;
        this.bug_host_url = window.perf ? window.perf.bug_host_url : '';
        this.bug_id = 0;
        this._show_pinpoint_buttons = ((_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : (_window_perf_git_repo_url = _window_perf.git_repo_url) === null || _window_perf_git_repo_url === void 0 ? void 0 : _window_perf_git_repo_url.includes('https://chromium.googlesource.com/chromium/src')) || false;
        this.show_bisect_button = !!((_window_perf1 = window.perf) === null || _window_perf1 === void 0 ? void 0 : _window_perf1.show_bisect_btn);
        this.tooltip_fixed = false;
        this._is_range = null;
        this._close_button_action = ()=>{};
        this.margin = {};
        this.containerDiv = (0, _ref.createRef)();
        this.json_source = window.perf ? window.perf.show_json_file_display : false;
        this._always_show_commit_info = window.perf ? window.perf.always_show_commit_info : false;
        this.handleCommitRangeChanged = ()=>{
            // handled by properties changes in Lit
            this.requestUpdate();
        };
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    }),
    _ts_metadata("design:type", Number)
], ChartTooltipSk.prototype, "index", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], ChartTooltipSk.prototype, "color", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], ChartTooltipSk.prototype, "test_name", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], ChartTooltipSk.prototype, "_trace_name", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], ChartTooltipSk.prototype, "unit_type", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    }),
    _ts_metadata("design:type", Number)
], ChartTooltipSk.prototype, "y_value", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", typeof Date === "undefined" ? Object : Date)
], ChartTooltipSk.prototype, "date_value", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "commit_position", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "commit_info", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "anomaly", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "_nudgeList", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], ChartTooltipSk.prototype, "bug_host_url", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    }),
    _ts_metadata("design:type", Number)
], ChartTooltipSk.prototype, "bug_id", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ChartTooltipSk.prototype, "_show_pinpoint_buttons", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ChartTooltipSk.prototype, "show_bisect_button", void 0);
_ts_decorate([
    (0, _decorators.query)('#triage-menu'),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "triageMenu", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    _ts_metadata("design:type", Boolean)
], ChartTooltipSk.prototype, "tooltip_fixed", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "_is_range", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Function)
], ChartTooltipSk.prototype, "_close_button_action", void 0);
_ts_decorate([
    (0, _decorators.query)('#tooltip-commit-range-link'),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "commitRangeSk", void 0);
_ts_decorate([
    (0, _decorators.query)('#tooltip-user-issue-sk'),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "userIssueSk", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "margin", void 0);
_ts_decorate([
    (0, _decorators.query)('#tooltip-point-links'),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "pointLinks", void 0);
_ts_decorate([
    (0, _decorators.query)('#json-source-sk'),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "jsonSourceDialog", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    _ts_metadata("design:type", Boolean)
], ChartTooltipSk.prototype, "json_source", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Boolean)
], ChartTooltipSk.prototype, "_always_show_commit_info", void 0);
_ts_decorate([
    (0, _decorators.query)('#bisect-dialog-sk'),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "bisectDialog", void 0);
_ts_decorate([
    (0, _decorators.query)('#pinpoint-try-job-dialog-sk'),
    _ts_metadata("design:type", Object)
], ChartTooltipSk.prototype, "tryJobDialog", void 0);
ChartTooltipSk = _ts_decorate([
    (0, _decorators.customElement)('chart-tooltip-sk')
], ChartTooltipSk);
